import { useLocation } from "react-router-dom";

import DeletedPressBoundary from "@/components/shared/business/DeletedPressBoundary/DeletedPressBoundary";
import { DesDealTypeDropdownDisplayNameProvider } from "@/contexts/desDealTypeDropdownDisplayNameContext";
import FillInTableContainer from "@FillInTableContainer/FillInTableContainer";
import { useSafeLeavePage } from "@hooks/useSafeLeavePage";

import FillInTableErrorBoundary from "./errors/components/FillInTableErrorBoundary/FillInTableErrorBoundary";

const FillInTablePage = () => {
  useSafeLeavePage();
  const location = useLocation();

  const getTypeFromPathname = (
    pathname: string,
  ): "publication" | "ctg" | "press" => {
    if (pathname.includes("publication")) return "publication";
    if (pathname.includes("ctg")) return "ctg";

    return "press";
  };

  const type = getTypeFromPathname(location.pathname);

  return (
    <DesDealTypeDropdownDisplayNameProvider>
      <FillInTableErrorBoundary>
        <DeletedPressBoundary type={type}>
          <FillInTableContainer />
        </DeletedPressBoundary>
      </FillInTableErrorBoundary>
    </DesDealTypeDropdownDisplayNameProvider>
  );
};

export default FillInTablePage;
